import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class ProductInventory extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }

  /**
   * Updates the inventory.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateInventory = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newInventory = event.detail.data.html.querySelector('product-inventory');

    if (!newInventory) return;

    morph(this, newInventory, { childrenOnly: true });
  };
}

const sendTodayEle    = document.querySelector('.today-ele');
const sendTomorrowEle = document.querySelector('.tomorrow-ele');
const sendFridayEle   = document.querySelector('.friday-ele');
const sendWeekendEle  = document.querySelector('.weekend-ele');

// --- Time helpers using Europe/Copenhagen ---

function getDenmarkTimeHM() {
  const now = new Date();
  return now.toLocaleString('en-GB', {
    timeZone: 'Europe/Copenhagen',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  }); // e.g. "15:50"
}

function getDenmarkWeekdayShort() {
  const now = new Date();
  return now.toLocaleString('en-GB', {
    timeZone: 'Europe/Copenhagen',
    weekday: 'short'
  }); // e.g. "Mon", "Tue", "Fri"
}

// --- Helper to toggle all messages ---

function showMessage(type) {
  const map = {
    today: sendTodayEle,
    tomorrow: sendTomorrowEle,
    friday: sendFridayEle,
    weekend: sendWeekendEle
  };

  Object.values(map).forEach(el => {
    if (el) el.style.display = 'none';
  });

  const active = map[type];
  if (active) active.style.display = 'block';
}

// --- Main logic: decide what to show based on DK weekday + time ---

function updateShippingMessage() {
  const dkTime    = getDenmarkTimeHM();       // "HH:MM"
  const dkWeekday = getDenmarkWeekdayShort(); // "Mon".."Sun"

  const isFriday  = dkWeekday === 'Fri';
  const isWeekend = dkWeekday === 'Sat' || dkWeekday === 'Sun';

  // Friday rules
  if (isFriday) {
    if (dkTime < '13:30') {
      // Before 13:30 on Friday -> show Friday message
      showMessage('friday');
    } else {
      // After 13:30 on Friday -> show weekend message
      showMessage('weekend');
    }
    return;
  }

  // Saturday + Sunday -> always weekend message
  if (isWeekend) {
    showMessage('weekend');
    return;
  }

  // Monday–Thursday logic (your original today/tomorrow cutoff)
  if (dkTime >= '00:01' && dkTime < '15:50') {
    // Between 00:01 and 15:49 → show today
    showMessage('today');
  } else {
    // From 15:50 onwards → show tomorrow
    showMessage('tomorrow');
  }
}

// --- Bootstrapping ---

updateShippingMessage();
setInterval(updateShippingMessage, 20 * 1000);


if (!customElements.get('product-inventory')) {
  customElements.define('product-inventory', ProductInventory);
}

